import React from 'react';
import PropTypes from 'prop-types';
import {UBadge, UTags} from "../index";
import UCustomScrollBar from "../UScrollbar";
import UCount from "../UCount";

const Empty = (props) => <>{props?.children}</>
const SideBar = (props) => {

    const scrollMenu = () => {
        props?.scrollMenu?.();
    }

    const Container = props.scrollBar ? UCustomScrollBar : Empty

    return (
        <React.Fragment>
            <Container onScroll={scrollMenu}>
                <ul className={`u_menu ${props.open ? 'u_active' : ''}`}>
                    {props.list.map((data, i) => {
                        return (
                            data?.isAccess && <li className={`${props.active === data.route ? 'u_active-menu' : ''} ${data.active ? 'u_active-menu-item' : ''} ${(props.active === data.route && !data?.inner_menu && props?.module === 'survey') ? 'u_event-none' : '' }`} key={i}
                                                  onClick={(e) => props.onClick(data, i, e)}>
                                <div className="u_menu-item">
                                    <div data-class="u_tooltip" data-tip={data.name}>
                                        <div className="u_menu-icon">
                                            {data.icon}
                                            <span className="u_menu-name">{data.name}</span>
                                            {data.betaVersion && <UTags title="BETA" color="#007aff" className="u_beta-tag"/>}
                                        </div>
                                    </div>
                                    {data.messageBadge !== 0 && data.messageBadge !== undefined && <UBadge count={data.messageBadge}/>}
                                    {data.inboxBadge !== 0 && data.inboxBadge !== undefined && <UCount count={data.inboxBadge}/>}
                                    {data.notificationBadge !== 0 && data.notificationBadge !== undefined && <UBadge count={data.notificationBadge}/>}
                                </div>
                                {
                                    !props.isOpen && data?.inner_menu?.length !== 0 &&
                                    <ul className="u_menu-item-list">
                                        {
                                            data?.inner_menu?.map(menu => {
                                                return (
                                                    menu?.isAccess && <li onClick={(e) => props.onInnerClick(e, menu, data.route)}
                                                                          className={`${menu.route === props?.inner_active ? 'u_active-inner-menu' : ''}`}>{menu.name}</li>
                                                )
                                            })
                                        }
                                    </ul>
                                }
                            </li>
                        );
                    })}
                </ul>
            </Container>
            {/*<ReactTooltip place="bottom" effect='solid' scrollHide={true} resizeHide={true} delayShow={1000} className="u_react-tooltip"/>*/}
        </React.Fragment>
    );
};

SideBar.propTypes = {
    width: PropTypes.number,
    largeLogo: PropTypes.string,
    collapsedLogo: PropTypes.string,
    sidebarData: PropTypes.array.isRequired,
    open: PropTypes.bool,
    close: PropTypes.func,
    scrollBar: PropTypes.bool
};

SideBar.defaultProps = {
    width: 300,
    largeLogo: '',
    collapsedLogo: '',
    sidebarData: null,
    open: false,
    close: null,
    scrollBar: true
};

export default SideBar;
